import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import intl from 'react-intl-universal';
import MessagingPres from 'src/ui/features/Messaging/presentational/MessagingPres';
import { storeCaseManagerId, getCaseMessagesCountsPending } from 'src/ui/features/Cases/state/casesActions';
import { getPaginatedMessages, clearAllMessagesAndCounts, resetMenu } from '../state/messagingActions';
import { addToHistory } from 'src/utils/utilsActions';
import debounce from 'lodash.debounce';
import { trackClickAnalytics } from 'src/helpers/adobeUtils';
//import { trackSearchAnalytics, trackClickAnalytics } from 'src/helpers/adobeUtils';
import { PageTitle } from 'src/ui/library/PageTitle';
import { setComposeClick } from '../../../../new-ui/features/NewDashboard/state/newDashboardAction';

import {
  deepLinkInbox,
  checkStatusPending,
  hideNotificationSuccess,
  getCasesMessagesPending,
  runMessagingMonitor,
  selectDetailView,
  selectMenuAndReset,
  stopMessagingMonitor,
  switchView,
  selectMessage,
  clearFilters,
  resetFilters,
  searchMessages,
  setFilters,
} from '../state/messagingActions';

import { MESSAGEBOX_VIEWS } from 'src/constants/constants';
import { DEFAULT_DASHBOARD_VIEW, DEFAULT_SESSION_KEY } from '../../../../constants/constants';

import { toggleDrawer } from 'src/utils/utilsActions';
import { getMessages, getMessageShown, checkIsComposeView, checkIsDraftView } from 'src/ui/features/Messaging/state/messagingReselect';
import { isEYProSelector } from 'src/ui/features/Login/state/loginReselect';
import { MESSAGEDETAIL_TYPES, MESSAGEORDER_TYPES } from 'src/constants/constants';
import { fireViewStartCustomEvent } from 'src/helpers/adobeCustomEvents';
import adobeLaunch from 'src/helpers/adobeLaunch';
import { StorageService } from 'src/helpers/localStorageService';
import { LAUNCH_ADOBE } from 'src/constants/constants';
import { fnGetMessageValue, fnRemoveMessageKey } from 'src/helpers/commonFunctions';

class MessagingContainer extends Component {
  static propTypes = {
    fetchMessages: PropTypes.func,
    messageData: PropTypes.object,
    isDraftView: PropTypes.bool,
    isComposeView: PropTypes.bool,
    showToastMessage: PropTypes.bool,
    toastMessage: PropTypes.string,
    hideNotificationSuccess: PropTypes.func,
  };
  constructor(props) {
    super(props);
    if (props.showCompose) {
      props.selectDetailView(MESSAGEDETAIL_TYPES.COMPOSE);
    }
    this.messageListRef = React.createRef();
    this._handleScroll = debounce(this.handleScroll, 200);
    this.props.clearAllMessagesAndCounts();
    if (LAUNCH_ADOBE) {
      let launch = new adobeLaunch();
      launch._load().then(() => {
        let storageService = new StorageService();
        storageService.setItem('pageName', 'messaging');
        window.digitaldata.page.pageName = storageService.getItem('pageName');
        window.digitaldata.user.userId = storageService.getItem('userId');
      });
    }

    fireViewStartCustomEvent({ detail: { mbox: 'target-global-mbox' } });
  }

  componentDidMount() {
    const {
      addToHistory,
      caseId,
      checkStatusPending,
      runMessagingMonitor,
      // selectMenuAndReset,
      match,
      selectedMessageId,
      selectMessage,
      switchView,
      userInfo,
      getCaseMessagesCountsPending,
      isCaseMessages,
      resetMenu,
    } = this.props;

    resetMenu();
    // eventually this should be moved into the root navigation
    // so we can refresh the counts for the little icons
    if (!userInfo || !userInfo.personId) {
      return checkStatusPending();
    }

    let defaultCaseId = fnGetMessageValue();

    if (defaultCaseId || (caseId && isCaseMessages)) {
      runMessagingMonitor(
        {
          mailBoxes: {
            inbox: true,
            sent: true,
            draft: true,
          },
          caseId: caseId ? caseId : defaultCaseId,
        },
        true,
      );
      this.props.setFilters({ caseId: caseId ? caseId : defaultCaseId, sortDirection: MESSAGEORDER_TYPES.DESC });

      Promise.resolve(getCaseMessagesCountsPending()).then(() => {
        fnRemoveMessageKey();
      });
    } else if (!defaultCaseId && !caseId && !isCaseMessages) {
      this.props.storeCaseManagerId(null);
      this.props.setFilters({ caseId: null, sortDirection: MESSAGEORDER_TYPES.DESC });
      runMessagingMonitor();
    }
    // selectMenuAndReset(MESSAGEBOX_TYPES.INBOX);

    // setup deep linking to inbox
    if (match && match.params && match.params.messageId) {
      this.props.deepLinkInbox(match.params.messageId);
    }

    // don't want to touch this but i believe this selectedMessageId is deprecated
    // @TODO - review later
    if (selectedMessageId) {
      selectMessage(selectedMessageId);
      switchView(MESSAGEBOX_VIEWS.DETAILS);
    }

    addToHistory(window.location.pathname);
    this.props.stopMessagingMonitor();
  }

  componentWillUnmount() {
    fnRemoveMessageKey();
    const list = findDOMNode(this.messageListRef.current);
    list.removeEventListener('scroll', this._handleScroll);

    if (!this.props.userInfo || !this.props.userInfo.personId) {
      return null;
    }
    this.props.stopMessagingMonitor();
    this.props.clearFilters();
    this.props.resetFilters();
    this.props.clearAllMessagesAndCounts();
  }

  componentDidUpdate(prevProps) {
    if (this.messageListRef.current !== null) {
      const list = findDOMNode(this.messageListRef.current);
      list.removeEventListener('scroll', this._handleScroll);
      if (this.props.selectedMenu !== prevProps.selectedMenu) {
        list.scrollTo(0, 0);
      } else {
        list.addEventListener('scroll', this._handleScroll);
      }
    }
    // if(this.props.resetCompose && this.state.newDashboard.composeClick){
    //   this.props.setComposeClick(false)
    // }
  }

  handleScroll = e => {
    const bottom = e.target.scrollHeight - 5 - e.target.scrollTop <= 3 * e.target.clientHeight;
    if (bottom) {
      this.props.getPaginatedMessages();
    }
  };

  render() {
    let default_view = sessionStorage.getItem(DEFAULT_SESSION_KEY);
    let isDefaultOldView =
      default_view === null
        ? (process.env.SHOW_DEFAULT_OLD_VIEW_ENV || 'false').toLowerCase() === 'true'
        : default_view.toLowerCase() === DEFAULT_DASHBOARD_VIEW.EXISTING.toLowerCase();
    return (
      <React.Fragment>
        <PageTitle title={this.props.pageTitle ? this.props.pageTitle : intl.get('messaging.pageTitle')} />
        <MessagingPres
          {...this.props}
          {...this.state}
          messageListRef={this.messageListRef}
          trackClickAnalytics={trackClickAnalytics}
          isDefaultOldView={isDefaultOldView}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    detailType: state.messaging.detailType,
    currentView: state.messaging.currentView,
    drawerState: state.utils.drawerState,
    isComposeView: checkIsComposeView(state),
    isDraftView: checkIsDraftView(state),
    isMobile: state.browser.is.small || state.browser.is.extraSmall,
    isTablet: state.browser.greaterThan.small && state.browser.lessThan.extraLarge,
    mediaType: state.browser.mediaType,
    messageData: getMessageShown(state),
    selectedMenu: state.messaging.selectedMenu,
    showToastMessage: state.messaging.showToastMessage,
    toastMessage: state.messaging.toastMessage,
    userInfo: state.login.userInfo,
    isEyPro: isEYProSelector(state),
    selectedMessageId: state.dashboard.selectedMessageId,
    messages: getMessages(state),
    state: state,
  };
};

const mapDispatchToProps = {
  selectMenuAndReset,
  runMessagingMonitor,
  getCasesMessagesPending,
  stopMessagingMonitor,
  hideNotificationSuccess,
  switchView,
  deepLinkInbox,
  selectDetailView,
  toggleDrawer,
  checkStatusPending,
  selectMessage,
  clearFilters,
  resetFilters,
  storeCaseManagerId,
  addToHistory,
  getCaseMessagesCountsPending,
  getMessages,
  searchMessages,
  getPaginatedMessages,
  clearAllMessagesAndCounts,
  setFilters,
  resetMenu,
  setComposeClick,
};

export default connect(mapStateToProps, mapDispatchToProps)(MessagingContainer);
